module.exports = __webpack_public_path__ + "static/media/s20fv.507e0607.png";